<template>
  <div>
    <!-- 1. POPUP MASUKKAN PIN LAMA -->
    <BModal
      id="modal-change-pin"
      ref="modal-change-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      modal-class="modal-primary"
      centered
      hide-header
    >
      <BRow class="justify-end">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Komerce"
          style="margin-right: 10px"
          class="cursor-pointer"
          @click="$bvModal.hide('modal-change-pin')"
        >
      </BRow>
      <BCol class="d-flex justify-content-center mt-2">
        <h4 class="text-black font-semibold">
          Masukkan PIN Lama
        </h4>
      </BCol>

      <BCol class="d-flex justify-content-center mt-2 mb-1">
        <CodeInput
          :loading="false"
          class="input"
          :type="isVisibilityOld ? 'text' : 'password'"
          @change="changePinLast"
        />
      </BCol>

      <BCol class="d-flex justify-content-center">
        <BButton
          variant="flat-primary"
          class="btn-icon"
          @click="isVisibilityOld = !isVisibilityOld"
        >
          {{ isVisibilityOld ? 'Sembunyikan' : 'Tampilkan' }}
        </BButton>
      </BCol>

      <!-- Pesan error PIN salah -->
      <BCol v-if="oldPinError" class="text-center mt-1">
        <small class="text-danger font-semibold">{{ oldPinError }}</small>
      </BCol>

      <!-- Tombol Lupa PIN -->
      <BCol class="d-flex justify-content-center">
        <BButton
          variant="flat-primary"
          size="sm"
          @click="goToForgotPin"
        >
          Lupa PIN
        </BButton>
      </BCol>

      <BCol class="d-flex justify-content-center mt-1 pb-1">
        <BButton
          variant="primary"
          block
          :disabled="pinLast === null || pinLast.length < 6 || loadingSubmit"
          @click="confirmPin"
        >
          <BSpinner v-if="loadingSubmit" variant="light" small />
          Konfirmasi
        </BButton>
      </BCol>

    </BModal>

    <!-- 2. POPUP MASUKKAN PIN BARU -->
    <BModal
      id="modal-new-pin"
      ref="modal-new-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      modal-class="modal-primary"
      centered
      hide-header
    >
      <BRow class="justify-end">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Komerce"
          style="margin-right: 10px"
          class="cursor-pointer"
          @click="$bvModal.hide('modal-new-pin')"
        >
      </BRow>
      <BCol class="d-flex justify-content-center mt-2">
        <h4 class="text-black font-semibold">
          Masukkan PIN Baru
        </h4>
      </BCol>

      <BCol class="d-flex justify-content-center mt-2 mb-1">
        <CodeInput
          :loading="false"
          class="input"
          :type="isVisibilityNew ? 'text' : 'password'"
          @change="onChange"
        />
      </BCol>

      <BCol class="d-flex justify-content-center">
        <BButton
          variant="flat-primary"
          class="btn-icon"
          @click="isVisibilityNew = !isVisibilityNew"
        >
          {{ isVisibilityNew ? 'Sembunyikan' : 'Tampilkan' }}
        </BButton>
      </BCol>

      <BCol class="d-flex justify-content-center mt-1 pb-2">
        <BButton
          variant="primary"
          block
          :disabled="dataPin === '' || dataPin.length < 6"
          @click="openConfirmPinModal"
        >
          Ganti PIN
        </BButton>
      </BCol>
    </BModal>

    <!-- 3. POPUP MASUKKAN ULANG PIN -->
    <BModal
      id="modal-confirm-change-pin"
      ref="modal-confirm-change-pin"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      centered
      hide-header
    >
      <BRow class="justify-end">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Komerce"
          style="margin-right: 10px"
          class="cursor-pointer"
          @click="$bvModal.hide('modal-confirm-change-pin')"
        >
      </BRow>
      <BCol class="d-flex justify-content-center mt-2">
        <h4 class="text-black font-semibold">
          Masukkan Ulang PIN Baru
        </h4>
      </BCol>

      <BCol class="d-flex justify-content-center mt-2 mb-1">
        <CodeInput
          :key="confirmInputKey"
          :loading="false"
          class="input"
          :type="isVisibilityConfirm ? 'text' : 'password'"
          @change="changePinConfirm"
        />
      </BCol>

      <BCol class="d-flex justify-content-center">
        <BButton
          variant="flat-primary"
          class="btn-icon"
          @click="isVisibilityConfirm = !isVisibilityConfirm"
        >
          {{ isVisibilityConfirm ? 'Sembunyikan' : 'Tampilkan' }}
        </BButton>
      </BCol>

      <!-- Pesan PIN tidak sama -->
      <BCol v-if="confirmPinError" class="text-center mt-1">
        <small class="text-danger font-semibold">{{ confirmPinError }}</small>
      </BCol>

      <BCol class="d-flex justify-content-center mt-1 pb-2">
        <BButton
          variant="primary"
          block
          :disabled="pinConfirm === null || pinConfirm.length < 6 || loadingSubmit"
          @click="onFinishChangePin"
        >
          <BSpinner v-if="loadingSubmit" small variant="light" />
          Ganti PIN
        </BButton>
      </BCol>
    </BModal>

    <!-- 4. POPUP SUKSES -->
    <BModal
      id="modal-success-update-pin"
      ref="modal-success-update-pin"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center p-2">
        <b-img
          center
          width="100"
          src="@core/assets/image/icon-popup-success.png"
          class="mb-2"
        />
        <h4 class="text-black font-bold">
          PIN Berhasil Diganti
        </h4>
        <BButton
          variant="primary"
          class="mt-2 px-3"
          @click="onSuccessOk"
        >
          OK
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script>
import CodeInput from 'vue-verification-code-input'
import { newAxiosIns } from '@/libs/axios'
import provider from '@/provider/provider'
import { UPDATE_PIN, CONFIRM_PIN } from '@/provider/url'
import {
  BCol, BButton, BSpinner, BModal, BRow,
} from 'bootstrap-vue'

export default {
  name: 'ModalChangePin',
  components: {
    CodeInput,
    BCol,
    BButton,
    BSpinner,
    BModal,
    BRow,

  },
  data() {
    return {
      isVisibilityOld: false,
      isVisibilityNew: false,
      isVisibilityConfirm: false,
      loadingSubmit: false,
      pinLast: '',
      dataPin: '',
      pinConfirm: '',
      confirmInputKey: 0,
      usableToken: '',
      encodedToken: '',
      oldPinError: '',
      confirmPinError: '',
    }
  },
  methods: {
    encodeToken(token) {
      return btoa(token)
    },

    // Step 1: Verifikasi PIN lama
    async confirmPin() {
      this.loadingSubmit = true
      this.oldPinError = ''
      try {
        const response = await newAxiosIns.post(CONFIRM_PIN, { pin: this.pinLast })
        const { data } = response.data

        if (data.is_valid) {
          this.usableToken = data.usable_token
          this.encodedToken = this.encodeToken(data.usable_token)

          // Pindah ke popup PIN Baru
          this.$bvModal.hide('modal-change-pin')
          this.dataPin = ''
          this.isVisibilityNew = false
          this.$bvModal.show('modal-new-pin')
        } else {
          const attemptLeft = data.attempt_left
          if (attemptLeft === 0) {
            this.$bvModal.hide('modal-change-pin')
            this.$bvModal.show('max-chance-PIN')
          } else {
            this.oldPinError = `PIN harus sama dengan PIN sebelumnya. Sisa ${attemptLeft} percobaan.`
          }
        }
      } catch (err) {
        const resData = err.response?.data
        const attemptLeft = resData?.data?.attempt_left

        if (attemptLeft === 0 || err.response?.status === 423 || err.response?.status === 429) {
        // Lock 24 jam
          this.$bvModal.hide('modal-change-pin')
          this.$bvModal.show('max-chance-PIN')
        } else {
          const baseMsg = resData?.message || 'PIN yang kamu masukkan salah'
          this.oldPinError = attemptLeft !== undefined
            ? `${baseMsg}. Sisa ${attemptLeft} percobaan.`
            : baseMsg
        }
      } finally {
        this.loadingSubmit = false
      }
    },

    // Step 2: Buka popup konfirmasi PIN
    openConfirmPinModal() {
      this.$bvModal.hide('modal-new-pin')
      this.pinConfirm = ''
      this.confirmPinError = ''
      this.isVisibilityConfirm = false
      this.confirmInputKey += 1
      this.$bvModal.show('modal-confirm-change-pin')
    },

    // Step 3: Submit update PIN (session-bound)
    async onFinishChangePin() {
      if (this.dataPin !== this.pinConfirm) {
        this.confirmPinError = 'PIN tidak sama'
        return
      }

      if (this.dataPin === this.pinLast) {
        this.confirmPinError = 'PIN baru tidak boleh sama dengan PIN lama'
        return
      }

      this.loadingSubmit = true
      this.confirmPinError = ''
      try {
        await newAxiosIns.post(UPDATE_PIN, {
          pin: this.dataPin,
          old_pin: this.pinLast,
          token: this.encodedToken,
        })

        // Sukses
        this.$bvModal.hide('modal-confirm-change-pin')
        this.$bvModal.show('modal-success-update-pin')
      } catch (err) {
        this.confirmPinError = err.response?.data?.message || 'Gagal memperbarui PIN, coba lagi'
      } finally {
        this.loadingSubmit = false
      }
    },

    // Sukses: reload halaman
    onSuccessOk() {
      this.$bvModal.hide('modal-success-update-pin')
      window.location.reload()
    },

    // Pergi ke flow Lupa PIN
    goToForgotPin() {
      this.$bvModal.hide('modal-change-pin')
      this.$bvModal.show('modal-forgot-pin')
    },

    changePinLast(value) {
      this.pinLast = value
      this.oldPinError = ''
    },
    onChange(value) {
      this.dataPin = value
    },
    changePinConfirm(value) {
      this.pinConfirm = value
      this.confirmPinError = ''
    },
  },
}
</script>
